var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 376,
    viewBox: "0 0 199 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4722 160.831C34.9415 158.644 31.7792 157.353 28.5426 157.208L-116.049 151.314C-110.976 124.977 -97.705 101.533 -78.0654 84.211C-58.4258 66.8892 -33.3835 56.5418 -6.38745 54.5939L10.0331 53.7236L-43.6904 0L-46.5971 0.699502C-75.5277 8.01299 -101.729 22.2831 -123.029 42.3265C-144.328 62.3699 -160.113 87.6092 -169.072 115.952L-169.326 116.807C-173.292 129.783 -175.808 143.263 -176.829 157.016C-177.25 169.648 -176.893 182.357 -175.759 195.072C-175.5 198.529 -173.942 201.866 -171.4 204.408C-168.858 206.95 -165.522 208.508 -162.065 208.767L-15.0435 214.043L-9.76666 361.065C-9.50777 364.522 -7.94989 367.858 -5.4079 370.4C-2.86591 372.942 0.470673 374.5 3.92758 374.759C16.6426 375.893 29.3518 376.25 41.9838 375.829C55.7364 374.808 69.2173 372.292 82.1926 368.326L83.0483 368.072C111.391 359.112 136.63 343.328 156.673 322.029C176.717 300.729 190.987 274.528 198.3 245.597L199 242.69L145.276 188.967L144.406 205.387C142.458 232.383 132.111 257.426 114.789 277.065C97.4671 296.705 74.0231 309.976 47.686 315.049L41.7916 170.457C41.6466 167.221 40.3563 164.058 38.1684 161.528L38.1966 161.499C38.0792 161.384 37.9601 161.271 37.8394 161.159C37.7285 161.039 37.6156 160.92 37.5005 160.803L37.4722 160.831Z",
    fill: "#FFBC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRight);
export default __webpack_public_path__ + "static/media/logo-right.482616da1a8e938d4f979c4812c62f3c.svg";
export { ForwardRef as ReactComponent };